import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";
import { useSlug } from "@/hooks/useSlug";
import { TicketCategoryForm } from "@/modules/ticket-categories/components/TicketCategoryForm";
import {
  getTicketCategoryFormValues,
  mapTicketCategoryFormToRequest,
} from "@/modules/ticket-categories/components/ticketCategoryFormMapping";
import { usePermissionQueries } from "@/queries/permissions/queryOptions";
import { useAddTicketCategory } from "@/queries/ticket-categories/mutations";
import { routes } from "@/routes";

export function CreateTicketCategoryPage(): React.ReactNode {
  const slug = useSlug();
  const navigate = useNavigate();
  const permissionQueries = usePermissionQueries();
  const permissionsQuery = useQuery(permissionQueries.listDefaultTicketCategories());
  const rolesQuery = useQuery(permissionQueries.listRoles());
  const createCategory = useAddTicketCategory();
  const error = permissionsQuery.error ?? rolesQuery.error;

  if (error) {
    return <ErrorPage error={error} />;
  }
  if (permissionsQuery.isPending || rolesQuery.isPending) {
    return <FullSizeLoader withPadding />;
  }

  return (
    <TicketCategoryForm
      ticketCategory={undefined}
      isEditMode={false}
      isSubmitting={createCategory.isPending}
      defaultFormValues={getTicketCategoryFormValues(rolesQuery.data ?? [], permissionsQuery.data ?? [])}
      onSubmit={(values) => {
        createCategory.mutate(mapTicketCategoryFormToRequest(values), {
          onSuccess: () => void navigate(routes.ticketCategories.list({ slug })),
        });
      }}
    />
  );
}
